import ELearning from "./ELearning";

export default ELearning;